import React from 'react';
import { Grid, Card, Typography, Stack, Skeleton, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import styles from './styles';
import CrossSellPreCardInfo from './CrossSellPreCardInfo';

const { publicRuntimeConfig } = getConfig();

const CrossSellPreCard = ({
  card,
  loading = false,
  tvSelected = false,
  selectTariff,
  modalCmsData,
  removeTariff,
  showLoader = false,
  // offerSelected = '',
  selected,
  setSelected,
  createCSForECC,
  subscriptions,
  setOpenSubscriptionSelectionModal,
  openDialog,
}) => {
  const theme = useTheme();

  const renderContent = content => ({ __html: content });

  return (
    <Grid item xs={11} sm={6} md={4.6} sx={{ paddingLeft: '0px !important' }}>
      <Card
        sx={
          loading
            ? styles(theme, card?.img).addon_cards
            : styles(theme, card?.img).addon_cards_withImg
        }
      >
        <Stack sx={{ textAlign: 'left' }} direction='column'>
          {loading ? (
            <>
              <Skeleton
                variant='rectangular'
                sx={{ m: '0 auto', height: { xs: 90 }, width: { xs: 47 } }}
              />
              <Skeleton height={24} width='50%' sx={{ m: '1rem auto 0' }} />
              <Skeleton height={16} width='60%' sx={{ m: 'auto' }} />
              <Skeleton height={24} width='20%' sx={{ m: '1rem auto 0' }} />
            </>
          ) : (
            <Grid
              container
              xs={12}
              sx={{ flexDirection: 'column', xs: { justifyContent: 'center' } }}
            >
              <Grid
                item
                xs={12}
                md='auto'
                sx={[
                  {
                    flex: { md: 1 },
                    marginBottom: '0.5rem',
                  },
                  styles(theme, null, card?.featureFontColor).addonCard_content,
                ]}
              >
                {card?.attributes?.map(description => (
                  <Stack direction='row' sx={{ alignItems: 'center', mt: '0.5rem' }}>
                    <Box
                      component='img'
                      sx={{
                        height: 23,
                        width: 35,
                      }}
                      src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${modalCmsData?.CSPreCards?.CSPreCard[1]?.featIcon?.data?.attributes?.url}`}
                    />
                    {description.feat?.includes('50tvChannelPopup') ? (
                      <Typography
                        variant='body1'
                        sx={{
                          paddingLeft: 0.5,
                          color: card?.featureFontColor
                            ? card?.featureFontColor
                            : theme.palette.secondary.contrastText,
                        }}
                        dangerouslySetInnerHTML={renderContent(description?.feat)}
                        onClick={() => {
                          openDialog();
                        }}
                      />
                    ) : (
                      <Typography
                        variant='body1'
                        sx={{
                          paddingLeft: 0.5,
                          color: card?.featureFontColor
                            ? card?.featureFontColor
                            : theme.palette.secondary.contrastText,
                        }}
                        dangerouslySetInnerHTML={renderContent(description?.feat)}
                      />
                    )}
                  </Stack>
                ))}
              </Grid>
              <Grid
                item
                xs={12}
                md='auto'
                sx={[
                  {
                    flex: { md: 1 },
                    justifyContent: 'center',
                    marginTop: '9.5rem',
                    marginBottom: '0.5rem',
                  },
                  styles(theme).addonCard_content,
                ]}
              >
                <CrossSellPreCardInfo
                  info={card?.info}
                  cta={card?.ctaType}
                  tvSelected={tvSelected}
                  selectTariff={selectTariff}
                  removeTariff={removeTariff}
                  showLoader={showLoader}
                  selected={selected}
                  setSelected={setSelected}
                  createCSForECC={createCSForECC}
                  subscriptions={subscriptions}
                  modalCmsData={modalCmsData}
                  setOpenSubscriptionSelectionModal={setOpenSubscriptionSelectionModal}
                />
                <Typography
                  sx={
                    ([styles(theme).infoText1],
                    {
                      textAlign: 'center',
                      color: modalCmsData?.CSPreCards?.CSPreCard[0]?.AfterPriceFontColour,
                      height: '1.5rem',
                      fontSize: '12px',
                      marginTop: '8px',
                    })
                  }
                >
                  {card?.info?.price !== card?.info?.afterPrice &&
                    `${card?.info?.afterPrice} per
                  month thereafter`}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Stack>
      </Card>
    </Grid>
  );
};

export default CrossSellPreCard;
